// Puantaj ve günlük program — servis satırı (eksik metrik / sürücüsüz / yolcu yok).

import React from "react";

import { KIND_META, formatKm, formatMinutes } from "../utils";

const ISSUE_TAG_KEYS = {
  MISSING_METRICS: "driverPerformance.metricsMissing",
  NO_PASSENGERS: "driverScheduler.noPassengersIssueTag",
  UNASSIGNED: "driverScheduler.unassignedIssueTag",
};

const ISSUE_HINT_KEYS = {
  MISSING_METRICS: "driverPerformance.metricsMissingHint",
  NO_PASSENGERS: "driverScheduler.noPassengersIssueHint",
  UNASSIGNED: "driverScheduler.unassignedIssueHint",
};

const ServiceMetricsRow = ({ service, t }) => {
  if (!service) return null;

  const meta = KIND_META[service.kind];
  const issueType = service.issueType || (service.metricsMissing ? "MISSING_METRICS" : null);
  const hasIssue = !!issueType;
  const issueTagKey = ISSUE_TAG_KEYS[issueType];
  const issueHintKey = ISSUE_HINT_KEYS[issueType];

  return (
    <div
      className={`dp-service-row${hasIssue ? " dp-service-row--missing" : ""}`}
      title={issueHintKey ? t(issueHintKey) : undefined}
    >
      <span
        className="dp-service-row__kind"
        style={{ backgroundColor: meta?.bg || "#bbb", borderColor: meta?.border || "#999" }}
      >
        {t(meta?.labelKey || "driverPerformance.kind.STANDARD_PERSONEL")}
      </span>
      <span className="dp-service-row__time">
        {service.startTime && service.endTime ? `${service.startTime} → ${service.endTime}` : "--:-- → --:--"}
      </span>
      <span className="dp-service-row__name">{service.name}</span>
      {service.schoolName && <span className="dp-service-row__school">{service.schoolName}</span>}
      {issueTagKey && (
        <span className="dp-tag dp-tag--warn dp-service-row__missing-tag">{t(issueTagKey)}</span>
      )}
      <span className={`dp-service-row__metrics${issueType === "MISSING_METRICS" ? " dp-service-row__metrics--missing" : ""}`}>
        {formatKm(service.km)} · {formatMinutes(service.minutes)}
      </span>
    </div>
  );
};

export default ServiceMetricsRow;
